import { Button } from 'react-aria-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons/faCircleCheck';



interface UploadSuccessProps {
	uploadReset: () => void,
}


export const UploadSuccess = (props: UploadSuccessProps) => {
	const { uploadReset } = props;

	return (
		<div className='droppable-file-input-info'>
			
			<h1>Soubor odeslán</h1>

			<FontAwesomeIcon className="info-icon" icon={faCircleCheck} />

			<Button className="app-highlight-button btn" onPress={uploadReset}>
				Nahrát další
			</Button>

		</div>
	)
}

export default UploadSuccess;